import Vue from 'vue'
import FullLearBoard from './FullLeaderBoard.vue'
import Affiliate from './Affiliate.vue'
import Admin from './Admin.vue'
//import axios from 'axios'
//import VueAxios from 'vue-axios'
import Meta from 'vue-meta'
 
Vue.use(Meta)
Vue.config.productionTip = false

if(document.getElementById('cc-full-leaderboard')){
  new Vue({
    render: h => h(FullLearBoard)
  }).$mount('#cc-full-leaderboard')
}
if(document.getElementById('cc-leaderboard-affiliate')){
  new Vue({
    render: h => h(Affiliate)
  }).$mount('#cc-leaderboard-affiliate')
}
if(document.getElementById('cc-full-leaderboard-admin')){
  new Vue({
    render: h => h(Admin)
  }).$mount('#cc-full-leaderboard-admin')
}